import React, { useContext, useEffect, useState } from "react";
import "./PartRequestItem.css";
import { PartRequestItemTask } from "../PartRequestItemTask/PartRequestItemTask";
import { attachContextmenuInfo } from "../../../../../services/contextMenuService";
import { Snackbar, Tooltip } from "@mui/material";
import { DialogContext } from "../../../../../contexts/DialogContext";
import { DeletePRNModal } from "./DeletePRNModal/DeletePRNModal.jsx";
import { deletePartRequest, getPRNEditionForm, getPRNListDetails, savePartRequest } from "../../../Services/partRequestService";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import { environment } from "../../../../../environments/environment";
import { useNavigate } from "react-router-dom";
import { clearActiveTab } from "../../../../../redux/features/TabsManager/tabSlice";
import { useDispatch } from "react-redux";
import { usePermissions } from "../../../../../hooks/usePermissions.jsx";
import BasicDatePicker from "../../../../../components/Datepicker/Datepicker.jsx"
export const PartRequestItem = ({
  initialData,
  itemOpened,
  idx,
  emitItemOpened,
  contextMenuInfo,
  reload,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [itemTasks, setItemTasks] = useState([]);
  const [taskOpened, setTaskOpened] = useState(null);
  const { openDialog, closeDialog } = useContext(DialogContext);
  const { errorMsg, successMsg, warningMsg } = useSnackBar()
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(environment.ElemensPerPage);
  const [orderBy, setOrderBy] = useState("id");
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch()
  // req_id
  const { hasPermission } = usePermissions()
  const [editPosted, setEditPosted] = useState(false)
  const [dateRequired, setDateRequired] = useState(initialData.date_required)
  const [bodyToUpdate, setBodyToUpdate] = useState(null)

  const partRequestNumber = {
    prn: "125-654-896",
    wp: "202408001",
    location: 26,
    site: 1,
    aircraft: 181,
    dateRequired: "2024-08-30",
    itemTasks: [
      {
        taskNumber: "202408-001",
        description: "Landing gear inspection",
        date: "2024-08-25",
        parts: [
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            pdescription: "Part Description",
            assignedSN: "001234",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            pdescription: "Part Description",
            assignedSN: "001234",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            pdescription: "Part Description",
            assignedSN: "001234",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            pdescription: "Part Description",
            assignedSN: "001234",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
        ],
      },
      {
        taskNumber: "202408-003",
        description: "Electrical System Inspection",
        date: "2024-08-25",
        parts: [
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            pdescription: "Part Description",
            assignedSN: "001234",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            pdescription: "Part Description",
            assignedSN: "001234",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            pdescription: "Part Description",
            assignedSN: "001234",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            pdescription: "Part Description",
            assignedSN: "001234",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
        ],
      },
      {
        taskNumber: "202408-004",
        description: "Landing gear inspection",
        date: "2024-08-25",
        parts: [
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            pdescription: "Part Description",
            assignedSN: "001234",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            pdescription: "Part Description",
            assignedSN: "001234",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            pdescription: "Part Description",
            assignedSN: "001234",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
          {
            pn: "111-222-333",
            qty: 12,
            uom: "Meters",
            assignedBatch: "456",
            assignedSN: "001234",
            pdescription: "Part Description",
            issueQuantity: 10,
            issueStatus: "Partially Dispatched",
            issueStatusReason: "Insufficient Inventory",
          },
        ],
      },
    ],
  };
  const getTaskOpened = (taskNum) => {
    setTaskOpened(taskNum);
  };

  const openDeletePRNDialog = () => {
    if (initialData.status == "Posted") {
      return;
    } else {
      openDialog({
        component: DeletePRNModal,
        props: {
          onclose: closeDialog,
          prn: initialData.id,
          wp: initialData.wp,
          // location: initialData.location,
          deletePRN: deletePRN
        }
      })
    }
  }

  const deletePRN = async () => {
    let PRN_id = initialData.id
    let request = await deletePartRequest(PRN_id);

    if (request.data.responseCode == HTTP_RESPONSE_CODES.DELETED) {
      successMsg("PRN Deleted", "PRN Has Been Deleted Successfully.");
      closeDialog()
      reload()
    }
  }

  const getListDetails = async () => {
    const body = [
      {
        columnName: "part_request_id",
        value: initialData.id
      },
      {
        columnName: "company_id",
        value: [parseInt(localStorage.getItem("u_company_id"))],
      },
    ];
    let request = await getPRNListDetails(page, pageSize, orderBy, search, body)

    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      setItemTasks(request.data.load)
    }
  }
  const forceHideTooltips = () => {
    const tooltips = document.querySelectorAll(".MuiTooltip-tooltip");
    tooltips.forEach((tooltip) => {
      const parent = tooltip.parentElement;
      if (parent) {
        parent.removeChild(tooltip);
      }
    });
  };

  const cancelEditPosted = () => {
    setEditPosted(false)
  }

  const editPartRequest = () => {
    forceHideTooltips()
    const basePath = environment.basePath
    if (initialData.status == "Posted") {
      setEditPosted(true)
      getPRNEditiForm()
    } else {
      dispatch(clearActiveTab("/store/part-request-management"));
      navigate(
        basePath + "/store/new-part-request?req_id=" + initialData.id + "&mode=edit"
      );
    }
  }

  const getPRNEditiForm = async () => {
    let request = await getPRNEditionForm(initialData.id)
    if (request.data.responseCode == 204) {
      setBodyToUpdate(request.data.load)
    } else {
      errorMsg("Error", "Error getting PRN edition form")
    }
  }

  const updatePRNPosted = async () => {

    let request = await savePartRequest(bodyToUpdate)
    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      successMsg("PRN Updated", "PRN Has Been Updated Successfully.")
      setEditPosted(false)
      setBodyToUpdate(request.data.load)
    } else {
      errorMsg("Error", "Error updating PRN")
    }
  }

  // useEffect

  useEffect(() => {
    setBodyToUpdate((prevData) => {
      return { ...prevData, dateRequestRequired: dateRequired }
    })
  }, [dateRequired])

  useEffect(() => {
    if (itemOpened !== idx) {
      setIsOpen(false);
    }
  }, [itemOpened]);

  useEffect(() => {
    if (isOpen) {
      getListDetails()
    }
  }, [isOpen]);

  return (
    <div
      className="PartRequestItem"
      onContextMenu={(event) => {
        if (contextMenuInfo)
          attachContextmenuInfo({
            event,
            ...contextMenuInfo,
            data: partRequestNumber,
          });
      }}
    >
      <div
        className={`PartRequestItem-header ${initialData?.part_request_type === 'Workpackage' ? 'wp' : initialData?.part_request_type === 'Transfer' ? 'Transfer' : ''}`}
        onClick={() => {
          setIsOpen(!isOpen);
          emitItemOpened(idx);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            setIsOpen(!isOpen);
            emitItemOpened(idx);
          }
        }}
        style={{
          background: isOpen ? "#EFFCFF" : "",
          border: isOpen ? "1px solid #B9D8DF" : "",
          position: isOpen ? "sticky" : "relative",
          top: isOpen ? 0 : "",
          gridTemplateColumns : initialData?.part_request_type === 'Transfer' && isOpen  ? "2% 7.5% 5% 15.8% 14.5% 7.5% 8.5% 8% 5%" :
            initialData?.part_request_type === 'Transfer' && !isOpen ? "3% 8% 5% 15.6% 14.2% 7.4% 8.4% 7.9% 5%" : 
             initialData?.part_request_type === 'Workpackage' && isOpen ? "2% 7.5% 5% 15.8% 14.5% 7.5% 8.5% 8% 5%" : 
             initialData?.part_request_type === 'Workpackage' && !isOpen ? "3% 6% 5% 15.6% 14.2% 7.4% 8.4% 7.9% 5%" : "",

          paddingLeft : initialData?.part_request_type === 'Transfer' && isOpen ? "1.8rem" : initialData?.part_request_type === 'Workpackage' && isOpen ?  "1.8rem" : "",
        }}
        tabIndex="0"
      >
        <span className='PartRequestItem-dot-span'
          style={{
            display: isOpen && itemTasks.length > 0 ? "flex" : "none",
            backgroundColor: initialData?.availability == "warning" ? "var(--yellow-100)" : initialData?.availability == "success" ? "var(--green-250)" : initialData?.availability == "error" ? "var(--red-300)" : ""

          }}
        ></span>
        <div style={{
          backgroundColor: initialData?.availability == "warning" ? "var(--yellow-100)" : initialData?.availability == "success" ? "var(--green-250)" : initialData?.availability == "error" ? "var(--red-300)" : initialData?.availability == "issued" ? "var(--blue-300)" :  ""
        }}>
          <i className={initialData?.availability == "warning" ? "icon-warning" : initialData?.availability == "success" ? "icon-success" : initialData?.availability == "error" ? "icon-error" : initialData?.availability == "issued" ? "icon-issued" : ""}></i>
        </div>
        <p style={{ width: "10%", minWidth: "5rem" }}>
          <Tooltip title={initialData?.id} arrow>
            <span className="ellipsis">{initialData.id}</span>
          </Tooltip>
        </p>
        <p style={{ width: "8%", minWidth: "5rem" }}>
          <Tooltip title={initialData?.wp} arrow>
            <span className="ellipsis">{initialData.wp ? initialData.wp : "--"}</span>
          </Tooltip>
        </p>
        {
          initialData?.part_request_type === 'Transfer' ? <p style={{ width: "20%", minWidth: "9rem" }}>
            <Tooltip title={initialData?.location} arrow>
              <span className="ellipsis">{initialData.origin_location ? initialData.origin_location : "--"}</span>
            </Tooltip>
          </p> : null
        }
        <p style={{ width: "17%", minWidth: "5rem" }}>
          <Tooltip title={initialData?.location} arrow>
            <span className="ellipsis">{initialData.location ? initialData.location : "--"}</span>
          </Tooltip>
        </p>
        <p style={{ width: "8%", minWidth: "5rem" }}>
          <Tooltip title={initialData?.tail_number} arrow>
            <span className="ellipsis">{initialData.tail_number ? initialData.tail_number : "--"}</span>
          </Tooltip>
        </p>
        <p style={{ width: "11%", minWidth: "5rem", }}>
          {editPosted ?
            <BasicDatePicker
              onChange={(e) => {
                setDateRequired(e.$d)
              }}
              value={dateRequired}
              disablePastDates={true}
            /> :
            <Tooltip title={`${new Date(dateRequired).toLocaleDateString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric'
            }).replace(/\//g, '-')}`} arrow>
              <span className="ellipsis" >
                {initialData.date_required ? new Date(dateRequired).toLocaleDateString('en-US', {
                  month: '2-digit',
                  day: '2-digit',
                  year: 'numeric'
                }).replace(/\//g, '-') : "--"}
              </span>
            </Tooltip>
          }
        </p>

        <p style={{ width: "10%", minWidth: "4rem" }}>
          <Tooltip title={initialData?.part_request_type ? initialData?.part_request_type : "--"} arrow>
            <span className="ellipsis">{initialData?.part_request_type ? initialData?.part_request_type : "--"}</span>
          </Tooltip>
        </p>

         <p style={{ width: "12%", minWidth: "6rem" }}>
          <Tooltip title={initialData?.part_request_type ? initialData?.part_request_type : "--"} arrow>
            <span className="ellipsis">{initialData?.company_name ? initialData?.company_name : "--"}</span>
          </Tooltip>
        </p>


        <span className="ellipsis" style={{
          backgroundColor: initialData?.status == "Posted" ? "rgba(0, 206, 136, 0.11)" : "var(--blue-500)",
          border: initialData?.status == "Posted" ? "1px solid rgb(0, 206, 136)" : "1px solid var(--blue-150)",
          color: initialData?.status == "Posted" ? "rgb(0, 206, 136)" : "var(--blue-150)",
        }}>
          {initialData.status}
        </span>

        {hasPermission("edit") && (
          <Tooltip title={editPosted ? "Save" : "Edit"} arrow>
            {!editPosted ? (
              <button onClick={(e) => { e.stopPropagation(); editPartRequest(); }} className="PartRequestItem-button-edit">
                <i className="icon-edit" style={{ color: "var(--grey-200)" }} />
              </button>
            ) : (
              <button onClick={(e) => {
                e.stopPropagation();
                updatePRNPosted();
              }} className="PartRequestItem-button-save">
                <i className="icon-save" style={{ color: "var(--white)" }} />
              </button>
            )}
          </Tooltip>
        )}

        {hasPermission("delete") && !editPosted && (
          <Tooltip title={initialData?.status == "Posted" ? "Cannot be deleted (Posted status)" : "Delete"} arrow>
            <button
              className="PartRequestItem-button-delete"
              onClick={(e) => { e.stopPropagation(); openDeletePRNDialog(); }}
              style={{ opacity: initialData?.status == "Posted" ? 0.5 : 1 }}
              disabled={initialData?.status == "Posted"}
            >
              <i className="icon-delete-new" style={{ color: "var(--grey-200)" }} />
            </button>
          </Tooltip>
        )}

        {editPosted && (
          <Tooltip title="Cancel editing" arrow>
            <button
              className="PartRequestItem-button-cancel"
              onClick={(e) => {
                e.stopPropagation();
                cancelEditPosted()
              }}
            >
              <i className="icon-cross" style={{ color: "var(--grey-200)" }} />
            </button>
          </Tooltip>
        )}

      </div>

      <section className={`PartRequestItem-content ${isOpen ? "open" : ""}`}>
        {itemTasks.map((task, idx) => {
          return (
            isOpen && <PartRequestItemTask
              key={idx}
              idx={idx}
              totalLength={itemTasks.length}
              emitItemOpened={getTaskOpened}
              itemTaskOpened={taskOpened}
              initialData={task}
              partReqId={initialData.id}
              PRNStatus={initialData.status}
            />
          );
        })}
      </section>
    </div>
  );
};
